import { Breadcrumb } from '../Breadcrumb';
import { Box, Stack } from '@mui/material';
import Sidebar from 'components/layout/Sidebar';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { Outlet, useOutletContext } from 'react-router-dom';

export const SidebarLayout = () => {
  //@ts-expect-error fix later
  const { openSideBar, setOpenSideBar } = useOutletContext();
  const { isMobile } = useBreakpoint();

  return (
    <Stack direction="row" justifyContent="center">
      <Sidebar open={openSideBar} setOpen={setOpenSideBar} />
      <Box sx={{ minWidth: isMobile ? '100%' : '500px', width: isMobile ? '100%' : '95%' }}>
        <Breadcrumb />
        <Outlet />
      </Box>
    </Stack>
  );
};
